<template lang="html">
  <img
    class="brand-logo"
    src="@/assets/logo.svg"
    alt="Omroep West"
    width="260"
  />
  <h1 class="p-0">Bedankt!</h1>
  <h2>Scan de QR-code op de grijpmachine en start je spel.</h2>
  <h2>Veel succes!</h2>
  <div class="center">
    <img
      :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getSavedDataId"
      width="250"
    />
  </div>
  <button
    type="button"
    class="btn btn-secondary text-light btn-lg rounded-0"
    @click="goToUrl()"
  >
    <span>Naar omroepwest.nl</span>
  </button>
</template>

<script>
export default {
  name: "QrCodeScreen",
  data: () => ({}),
  computed: {
    getSavedDataId: function () {
      let savedData = this.$store.getters.getSavedData;
      if (savedData !== null) {
        return savedData._id;
      }
      return false;
    },
  },
  methods: {
    goToUrl() {
      window.location.href = "https://www.omroepwest.nl/";
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 1.8rem;
  color: #ffffff;
  font-weight: 700;
}
h2 {
  font-size: 1.2rem;
  color: #ffffff;
}
.brand-logo {
  margin-bottom: 20px;
}
.center {
  text-align: center;
  margin: 16px 0;
}
img:not(.brand-logo) {
  max-width: 100%;
  height: auto;
  padding: 8px;
}
button {
  background-color: #ffffff !important;
  color: #db011c !important;
  border: none !important;
  min-height: 56px;
  font-weight: 600;
  font-size: 1rem;
}
button:hover {
  background-color: #f0f0f0 !important;
}

@media (min-width: 768px) {
  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.4rem;
  }

  button {
    min-height: 68px;
    font-size: 1.1rem;
  }
}
</style>
